// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hZEvU-aPmiF6ZipMvHSXc {\n  width: 100%;\n}\n\n.qel7A2JbJJLc239pO3aKr {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n._2rqZt9Pj6XM3W7OrchXT8W .Select-aria-only {\n  float: right !important;\n  width: 100%;\n  flex: 1;\n}\n\n._1erFF2nvCJBr0fjqjxByrs {\n\n}\n\n.JJb_bb2whq5jyNShchah {\n  border-radius: 3px;\n  border: 1px solid #87CEFA;\n  background: rgba(135, 206, 250, 0.05);\n  margin: 2px 0;\n  padding: 0.5em;\n}\n\n._1I9EQ_Ob7DwycGJgqoXY-T {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n._1I9EQ_Ob7DwycGJgqoXY-T > * {\n  margin: 2px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "hZEvU-aPmiF6ZipMvHSXc",
	"option": "qel7A2JbJJLc239pO3aKr",
	"inputContainer": "_2rqZt9Pj6XM3W7OrchXT8W",
	"service": "_1erFF2nvCJBr0fjqjxByrs",
	"display": "JJb_bb2whq5jyNShchah",
	"optionsContainer": "_1I9EQ_Ob7DwycGJgqoXY-T"
};
module.exports = exports;
